<script setup lang="ts">
/**
 * The root. Routing does the work; this holds the portal target the kit's
 * overlays mount into and nothing else.
 */
</script>

<template>
  <RouterView />
</template>
